import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from "sonner";
import { Coins, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

const BlockchainTab = () => {
  const [blockchainStatus, setBlockchainStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlockchainStatus();
  }, []);

  const fetchBlockchainStatus = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/blockchain/status`);
      setBlockchainStatus(response.data);
    } catch (error) {
      console.error("Failed to fetch blockchain status:", error);
      toast.error("Failed to connect to blockchain");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Blockchain Wallet Balance Card */}
      {loading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-gold-600" />
        </div>
      ) : blockchainStatus ? (
        <Card className="border-2 border-gold-500 bg-gradient-to-br from-gold-50 to-white">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-gold-700">
              <Coins className="w-6 h-6" />
              Blockchain Wallet
            </CardTitle>
            <CardDescription>Polygon Mainnet</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white p-6 rounded-lg border shadow-sm">
                <p className="text-sm text-gray-600 mb-2">Network Status</p>
                <p className="text-2xl font-bold text-gold-700 flex items-center gap-2">
                  {blockchainStatus.connected ? (
                    <>
                      <CheckCircle2 className="w-6 h-6 text-green-500" />
                      Connected
                    </>
                  ) : (
                    <>
                      <AlertCircle className="w-6 h-6 text-red-500" />
                      Disconnected
                    </>
                  )}
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg border shadow-sm">
                <p className="text-sm text-gray-600 mb-2">Wallet Balance</p>
                <p className="text-2xl font-bold text-gold-700">{blockchainStatus.balance_matic?.toFixed(4)} POL</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardContent className="text-center py-12">
            <AlertCircle className="w-16 h-16 text-red-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Unable to load blockchain status</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default BlockchainTab;
